/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card } from 'react-bootstrap';

import Modal from 'react-modal';
import * as S from './styles';
import { MapViewer } from './MapViewer';

export interface IMapModalProps {
  showModal: boolean;
  closeModal?(): void;
  markers?: any;
  center?: any;
  [key: string]: any;
  accessToken?: string;
}

export const MapModal = ({
  showModal,
  closeModal,
  accessToken,
  markers,
  center,
}: IMapModalProps) => {
  if (accessToken && markers) {
    return (
      <Modal
        isOpen={showModal}
        style={S.ModalStyle}
        onRequestClose={closeModal}
        appElement={
          typeof global.window !== 'undefined'
            ? global.window.document.body
            : undefined
        }
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'center',
          }}
        >
          <Card style={{ height: 'fit-content', display: 'flex' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                alignSelf: 'center',
              }}
            >
              {' '}
              <MapViewer
                accessToken={accessToken}
                markers={markers}
                center={center}
                closeModal={closeModal}
              />
            </div>
          </Card>
        </div>
      </Modal>
    );
  }
  return null;
};

MapModal.defaultProps = {
  showModal: false,
};
